/**
 * Activity's requests — every one carries this browser's device key
 * (`docs/activity.md` §4.6), so the server answers for this device.
 */
import { request, type RequestOptions } from '../lib/api.js'
import { activityHeaders } from '../lib/activity-device.js'
import type { FindResult } from '../requests/api.js'

export function activityRequest<T>(path: string, options: RequestOptions = {}): Promise<T> {
  return request<T>(path, { ...options, headers: { ...activityHeaders(), ...options.headers } })
}

/** `people=a,b` — the people button's people, in its order. */
export const peopleQuery = (ids: readonly string[]): string => ids.join(',')

/**
 * A meeting's one search for *With* and *Where* (Aaron, Oct 23): New
 * request's engine — contacts and properties together — answered by
 * `GET /activity/find` so it needs only what a meeting needs.
 */
export function meetingFind(text: string, limit: number, signal?: AbortSignal): Promise<FindResult> {
  const query = new URLSearchParams({ q: text, limit: String(limit) })
  return activityRequest<FindResult>(`/activity/find?${query.toString()}`, { signal })
}
